export const version = '1.8.6';
//# sourceMappingURL=version.js.map